import React from 'react';
import './Help.css';

// Put your images in /src/assets/help/ and import them like this:
import step1 from '../assets/images/step-1-right-click.png';
import step2 from '../assets/images/step-2-format-cells.png';
import step7 from '../assets/images/step-7-Numbers.png';
import step9 from '../assets/images/step-9-2rows.png';
import step10 from '../assets/images/all_numbers.png';
import step11 from '../assets/images/correct_format.png';

const Help = () => {
  const dateSteps = [
    {n:1,text:'Right click on the first date cell.',img:step1},
    {n:2,text:'Select "Format Cells".',img:step2},
    {n:3,text:'In "Category", select "Custom".'},
    {n:4,text:'In "Type", enter "mm/dd/yyyy", then click OK.'},

    // Add more steps the same way (img optional)
    {n:5,text:'Right click the same cell again.'},
    {n:6,text:'Select "Format Cells" again.'},
    {n:7,text:'In "Category", select "Number".',img:step7},
    {n:8,text:'Click OK.'},
    {n:9,text:'Drag down to the second row and increase the date by 1.',img:step9},
    {n:10,text:'Highlight both cells and drag down to fill the rest of the column.',img:step10},
    {n:11,text:'Save the file as CSV.'},
    {n:12,text:'Highlight the entire date column and set format to mm/dd/yyyy.',img:step11},
    {n:13,text:'Save the file as CSV again.'},
  ];

  return (
    <div className="help-container">
      <h1 className="text-3xl font-bold text-center">Help Center</h1>

      <div className="help-grid">
        {/* LEFT COLUMN */}
        <div className="help-left">
          <div className="faq-item">
            <h2>How do I reset my password?</h2>
            <p>Click "Forgot Password" on the login page and follow the instructions.</p>
          </div>

          <div className="faq-item">
            <h2>What file formats are supported?</h2>
            <p>We support CSV files for data uploads.</p>
          </div>

          <div className="faq-item">
            <h2>How can I contact support?</h2>
            <p>Use the Contact page or email us.</p>
          </div>

          <a href="/contact" className="support-btn">Contact Support</a>
        </div>

        {/* RIGHT COLUMN (INSTRUCTIONS) */}
        <aside className="help-right">
          <div className="faq-item">
            <h2>How to format the date</h2>
            <p className="muted">
              Date format must be <strong>mm/dd/yyyy</strong>. Follow the steps below to avoid errors.
            </p>

            <ol className="steps">
              {dateSteps.map((s) => (
                <li key={s.n} className="step">
                  <div className="step-text">
                    <span className="step-num">{s.n}</span>
                    <span>{s.text}</span>
                  </div>

                  {s.img ? (
                    <div className="step-image">
                      <img src={s.img} alt={`Step ${s.n}`} loading="lazy" />
                    </div>
                  ) : null}
                </li>
              ))}
            </ol>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default Help;